import React, { useEffect, useState } from "react";
import Withdraw from "./Withdraw";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { inRange, isEmpty, lowerCase, startCase } from "lodash";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useForm } from "react-hook-form";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { t } from "i18next";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import iconBkash from "../../assets/images/bkash.png";
import iconRocket from "../../assets/images/rocket.png";
import iconNagad from "../../assets/images/nagad.png";
import iconEth from "../../assets/images/eth.svg";
import iconBtc from "../../assets/images/btc.svg";
import iconUpay from "../../assets/images/upay.png";
import { FaRegCopy } from "react-icons/fa";
import bankImg from "../../assets/images/bank.png";
import { AmountArray, validationRules, bankType } from "../../Utils/constants";
import { formatWithCommas } from "../../Utils/Toast";
import ConditionalOutsideClick from "../../component/ConditionalOutsideClick";
import Layout from "../Layout";

const Deposit = () => {
  const [tab, setTab] = useState("deposit");
  const { type } = useParams();
  const { offerCode } = useParams();
  const navigate = useNavigate();
  const [offer, setOffer] = useState("");
  useEffect(() => {
    if (!isEmpty(type)) {
      setTab(type);
    }
  }, [type]);
  const [image, setImage] = useState("");
  const [bank, setBank] = useState([]);
  const [id, setId] = useState("");
  const [loader, setLoader] = useState(false);
  const [dataOffer, setDataOffer] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");


  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const [limit, setLimit] = useState(
    profileData?.limitSetting?.length > 0
      ? profileData?.limitSetting[0]
      : {
          minDeposit: "100",
          maxDeposit: "300000",
        },
  );
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });
  const uploadImage = async (obj) => {
    let form = new FormData();
    form.append("TransactionFile", obj);
    const { status, data } = await apiPost(apiPath.reciptUpload, form);
    if (status == 200) {
      return data?.path;
    } else {
      return false;
    }
  };

  const onSubmit = async (body) => {
    setLoader(true);
    let imageCheck = "";
    if (image !== "") {
      imageCheck = await uploadImage(image);
    }

    body = {
      amount: body?.amount,
      bank: id,
      transactionType: "deposit",
      bonus: body?.bonus,
      AccountName: body?.accountName,
      BankAccount: body?.bankAccount,
      payment: "online",
      // offer: offer,
      TransactionFile: image !== "" ? imageCheck : "",
      customerNumber: body?.customerNumber,
      TransactionId: body?.transactionId,
    };
    const { status, data } = await apiPost(apiPath.depositAmount, body);
    if (status == 200) {
      if (data?.success) {
        toast.success(data?.message);
        // amounutRefresh();
        reset();
        setLoader(false);
      } else {
        toast.error(data?.message);
        setLoader(false);
      }
    } else {
      toast.error(data?.message);
      setLoader(false);
    }
  };
  const getBankDetail = async (body) => {
    setId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };
  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "deposit",
    });
    if (status == 200) {
      if (data?.success) {
        setBank(data?.results?.bankList);
        if (data?.results?.bankList?.length > 0) {
          setSelectedMethod(data?.results?.bankList[0]?.bank_name);
          getBankDetail(data?.results?.bankList[0]?._id);
        }
      }
    }
  };
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional, {
      category: "Deposit",
    });
    if (status == 200) {
      if (data?.success) {
        let result = data?.results?.offerList?.filter((res) => {
          return res?.category == "Deposit";
        });
        let updated = getFilteredOfferList(
          profileData?.userDepositCount,
          result,
        );
        let find = updated?.find((res) => {
          return res?._id == offerCode;
        });
        if (!isEmpty(find)) {
          setLimit({
            minDeposit: find?.minimumDeposite,
            maxDeposit: find?.maximumDeposite,
          });
        }
        if (updated?.length > 0) {
          setDataOffer(updated);
          let find = updated?.find((res) => {
            return res?.offerOn == "OnDeposit";
          });
          if (!isEmpty(offerCode)) {
            setOffer(offerCode);
          } else {
            if (!isEmpty(find)) {
              setOffer(find?._id);
              setLimit({
                minDeposit: find?.minimumDeposite,
                maxDeposit: find?.maximumDeposite,
              });
            } else {
              setOffer(updated[0]?._id);
              setLimit({
                minDeposit: updated[0]?.minimumDeposite,
                maxDeposit: updated[0]?.maximumDeposite,
              });
            }
          }
        }
      }
    }
  };
  useEffect(() => {
    getBank();
  }, []);
  useEffect(() => {
    getData();
    setOffer(offerCode);
  }, [offerCode, profileData]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(watch("bankAccount"))
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const maskBankAccount = (value = "") => {
    if (!value) return "";
    const first4 = value.slice(0, 4);
    const masked = "*".repeat(Math.max(0, value.length - 4));
    return first4 + masked;
  };

  return (
    <Layout>
      <app-popup-page
        _ngcontent-serverapp-c2746482659
        className="ng-tns-c2746482659-0 popup-page-wrapper active"
        _nghost-serverapp-c2790459173
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page popup-page--active popup-page--align-top"
        >
          <div
            _ngcontent-serverapp-c2790459173=""
            class="popup-page__backdrop"
          ></div>
          <ConditionalOutsideClick onOutsideClick={() => navigate(-1)}>
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page__main popup-page-main popup-page-main--show"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__header"
              >
                <div
                  _ngcontent-serverapp-c2790459173
                  className="popup-page-main__title"
                >
                  {t("Mywallet")}
                </div>
                <div
                  onClick={() => navigate(-1)}
                  _ngcontent-serverapp-c2790459173
                  className="popup-page-main__close ng-star-inserted"
                />
              </div>
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__container"
              >
                <div
                  _ngcontent-serverapp-c2790459173
                  className="content fixed-tab player-content"
                >
                  <router-outlet
                    _ngcontent-serverapp-c2790459173
                    name="popup"
                  />
                  <ng-component className="ng-star-inserted">
                    <ng-component
                      _nghost-serverapp-c613070388
                      className="ng-tns-c613070388-172 ng-star-inserted"
                    >
                      <app-tab-button
                        _ngcontent-serverapp-c613070388
                        className="ng-tns-c613070388-172"
                        _nghost-serverapp-c1092228635
                      >
                        <div
                          _ngcontent-serverapp-c1092228635
                          className="tab-btn-section tab-btn-wrap ng-star-inserted"
                        >
                          <div
                            _ngcontent-serverapp-c1092228635
                            className="tab-btn tab-btn-bar"
                          >
                            <div
                              _ngcontent-serverapp-c1092228635
                              className="line"
                              style={{
                                width: "calc(50%)",
                                transform: `translate(${
                                  tab == "deposit" ? "0%" : "100%"
                                }, 0px)`,
                              }}
                            />
                            <div
                              onClick={() => setTab("deposit")}
                              _ngcontent-serverapp-c1092228635
                              drctablinkactive="active"
                              className={`btn ng-star-inserted ${
                                tab == "deposit" ? "active" : ""
                              }`}
                            >
                              <div
                                _ngcontent-serverapp-c1092228635
                                className="text"
                              >
                                {t("Deposit")}
                                <div
                                  _ngcontent-serverapp-c1092228635
                                  className="badge"
                                />
                              </div>
                            </div>
                            <div
                              onClick={() => setTab("withdraw")}
                              _ngcontent-serverapp-c1092228635
                              drctablinkactive="active"
                              className={`btn ng-star-inserted ${
                                tab == "withdraw" ? "active" : ""
                              }`}
                            >
                              <div
                                _ngcontent-serverapp-c1092228635
                                className="text"
                              >
                                {t("Withdrawal")}
                                <div
                                  _ngcontent-serverapp-c1092228635
                                  className="badge"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </app-tab-button>
                      {tab == "deposit" && (
                        <div
                          _ngcontent-serverapp-c613070388
                          className="ng-tns-c613070388-14 ng-trigger ng-trigger-tabPageTriggerAni"
                        >
                          <router-outlet
                            _ngcontent-serverapp-c613070388
                            className="ng-tns-c613070388-14"
                          />
                          <ng-component
                            _nghost-serverapp-c684031653
                            className="ng-tns-c684031653-19 ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c684031653
                              className="tab-content tab-content-page ng-tns-c684031653-19 ng-star-inserted"
                            >
                              <div
                                _ngcontent-serverapp-c684031653
                                className="inner-wrap ng-tns-c684031653-19"
                              >
                                <div
                                  _ngcontent-serverapp-c684031653
                                  className="inner-box deposit-wallet ng-tns-c684031653-19"
                                >
                                  {" "}
                                  <div className="player-top player-withdraw ng-tns-c2278473435-17">
                                    <div className="main-wallet-info ng-tns-c2278473435-17">
                                      <div className="operating-wallet ng-tns-c2278473435-17" />
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                        className="renew-main-wallet ng-tns-c2278473435-17"
                                      >
                                        <span className="ng-tns-c2278473435-17">
                                          {" "}
                                          Main Wallet Balance{" "}
                                        </span>
                                        <span className="ng-tns-c2278473435-17">
                                          BDT {userCoins?.totalCoins || 0}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    _ngcontent-serverapp-c684031653
                                    className="player-deposit-wrap ng-tns-c684031653-19"
                                  >
                                    <Form
                                      onSubmit={handleSubmit(onSubmit)}
                                      _ngcontent-serverapp-c684031653
                                      className="player-deposit-step1 ng-tns-c684031653-19"
                                    >
                                      {/* <div
                                        _ngcontent-serverapp-c684031653
                                        className="option-group select-bar ng-tns-c684031653-19"
                                      >
                                        <h2
                                          style={{ width: "auto" }}
                                          _ngcontent-serverapp-c684031653
                                          className="ng-tns-c684031653-19"
                                        >
                                          {t("Promotion")}
                                        </h2>
                                        <div
                                          _ngcontent-serverapp-c684031653
                                          className="option-wrap ng-tns-c684031653-19"
                                        >
                                          <select
                                            onChange={(e) => {
                                              let object = dataOffer?.find(
                                                (res) => {
                                                  return (
                                                    res?._id == e.target.value
                                                  );
                                                },
                                              );
                                              setOffer(e.target.value);
                                              setLimit({
                                                minDeposit:
                                                  object?.minimumDeposite,
                                                maxDeposit:
                                                  object?.maximumDeposite,
                                              });
                                            }}
                                            _ngcontent-serverapp-c684031653
                                            className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                                          >
                                            <option
                                              _ngcontent-serverapp-c684031653
                                              className="ng-tns-c684031653-19 ng-star-inserted"
                                              value={""}
                                            >
                                              {t("Normal")}
                                            </option>

                                            {dataOffer?.map((res) => {
                                              return (
                                                <option
                                                  _ngcontent-serverapp-c684031653
                                                  className="ng-tns-c684031653-19 ng-star-inserted"
                                                  value={res?._id}
                                                >
                                                  {res?.title}
                                                </option>
                                              );
                                            })}
                                          </select>
                                        </div>
                                      </div> */}

                                      <div
                                       
                                        _ngcontent-serverapp-c684031653
                                        className="menu-box ng-tns-c684031653-19"
                                      >
                                        <div
                                          _ngcontent-serverapp-c684031653
                                          className="title ng-tns-c684031653-19"
                                        >
                                          <h2
                                            _ngcontent-serverapp-c684031653
                                            className="ng-tns-c684031653-19"
                                          >
                                            <span
                                              style={{ width: "auto" }}
                                              _ngcontent-serverapp-c684031653
                                              className="ng-tns-c684031653-19"
                                            >
                                              {t("PaymentMethod")}
                                            </span>
                                          </h2>
                                        </div>
                                        {bank?.length > 0 && (
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="check-group ng-tns-c684031653-19"
                                          >
                                            <ul className="col3">
                                              {bank.map((method) => (
                                                <li
                                                  key={method?._id}
                                                  className="payment-option"
                                                >
                                                  <input
                                                    type="radio"
                                                    id={method?._id}
                                                    name="paymentMethod"
                                                    checked={
                                                      selectedMethod ===
                                                      method.bank_name
                                                    }
                                                    onChange={() => {
                                                      setSelectedMethod(
                                                        method.bank_name,
                                                      );
                                                      getBankDetail(
                                                        method?._id,
                                                      );
                                                    }}
                                                  />
                                                  <label htmlFor={method?._id}>
                                                    <div className="payment-img">
                                                      <img
                                                        src={
                                                          method?.bank_name
                                                            .toLowerCase()
                                                            .includes("bkash")
                                                            ? iconBkash
                                                            : method?.bank_name
                                                                  .toLowerCase()
                                                                  .includes(
                                                                    "nagad",
                                                                  )
                                                              ? iconNagad
                                                              : method?.bank_name
                                                                    .toLowerCase()
                                                                    .includes(
                                                                      "rocket",
                                                                    )
                                                                ? iconRocket
                                                                : method?.bank_name
                                                                      .toLowerCase()
                                                                      .includes(
                                                                        "eth",
                                                                      )
                                                                  ? iconEth
                                                                  : method?.bank_name
                                                                        .toLowerCase()
                                                                        .includes(
                                                                          "btc",
                                                                        )
                                                                    ? iconBtc
                                                                    : method?.bank_name
                                                                          .toLowerCase()
                                                                          .includes(
                                                                            "upay",
                                                                          )
                                                                      ? iconUpay
                                                                      : bankImg
                                                        }
                                                        loading="lazy"
                                                      />
                                                    </div>
                                                    <span>
                                                      {startCase(
                                                        method?.bank_name,
                                                      )}
                                                    </span>
                                                  </label>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        )}
                                        <div
                                          _ngcontent-serverapp-c684031653
                                          className="check-group ng-tns-c684031653-19 ng-star-inserted"
                                        >
                                          <ul
                                            _ngcontent-serverapp-c684031653
                                            className="col2 ng-tns-c684031653-19"
                                          >
                                            <app-basic-button
                                              _ngcontent-serverapp-c684031653
                                              radiogroupname="paymentType"
                                              _nghost-serverapp-c4271250685
                                              className="ng-tns-c684031653-19 ng-star-inserted"
                                            >
                                              <li
                                                _ngcontent-serverapp-c4271250685
                                                className="ng-star-inserted"
                                              >
                                                <input
                                                  _ngcontent-serverapp-c4271250685
                                                  type="radio"
                                                  name="paymentType"
                                                  id="paymentType_0"
                                                  checked
                                                />
                                                <label
                                                  _ngcontent-serverapp-c4271250685
                                                  htmlFor="paymentType_0"
                                                >
                                                  <span
                                                    _ngcontent-serverapp-c4271250685
                                                  >
                                                    {startCase(selectedMethod)}{" "}
                                                    Payment
                                                  </span>
                                                </label>
                                              </li>
                                            </app-basic-button>
                                          </ul>
                                        </div>
                                      </div>

                                      {!isEmpty(watch("bankAccount")) && (
                                        <>
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="ng-tns-c684031653-19 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-serverapp-c684031653
                                              className="menu-box active ng-tns-c684031653-19 ng-star-inserted"
                                            >
                                              <div
                                                _ngcontent-serverapp-c684031653
                                                className="title ng-tns-c684031653-19"
                                              >
                                                <h2
                                                  _ngcontent-serverapp-c684031653
                                                  className="ng-tns-c684031653-19"
                                                >
                                                  <span
                                                    style={{ width: "auto" }}
                                                    _ngcontent-serverapp-c684031653
                                                    className="ng-tns-c684031653-19"
                                                  >
                                                    {t("Account_Name")}
                                                  </span>
                                                </h2>
                                              </div>

                                              <div
                                                _ngcontent-serverapp-c684031653
                                                className="input-group money ng-tns-c684031653-19"
                                              >
                                                <input
                                                  _ngcontent-serverapp-c684031653
                                                  className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                                                  type="text"
                                                  readOnly
                                                  {...register("accountName")}
                                                />
                                              </div>
                                            </div>
                                          </div>{" "}
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="ng-tns-c684031653-19 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-serverapp-c684031653
                                              className="menu-box active ng-tns-c684031653-19 ng-star-inserted"
                                            >
                                              <div
                                                _ngcontent-serverapp-c684031653
                                                className="title ng-tns-c684031653-19"
                                              >
                                                <h2
                                                  _ngcontent-serverapp-c684031653
                                                  className="ng-tns-c684031653-19"
                                                >
                                                  <span
                                                    style={{ width: "auto" }}
                                                    _ngcontent-serverapp-c684031653
                                                    className="ng-tns-c684031653-19"
                                                  >
                                                    {t("Bank_Account")}
                                                  </span>
                                                </h2>
                                              </div>

                                              <div
                                                _ngcontent-serverapp-c684031653
                                                className="input-group money ng-tns-c684031653-19"
                                              >
                                                {" "}
                                                <FaRegCopy
                                                  onClick={() => handleCopy()}
                                                  color="white"
                                                  size={20}
                                                  style={{
                                                    position: "absolute",
                                                    left: "10px",
                                                  }}
                                                />
                                                <input
                                                  _ngcontent-serverapp-c684031653
                                                  className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                                                  type="text"
                                                  readOnly
                                                  value={maskBankAccount(
                                                    watch("bankAccount"),
                                                  )}
                                                  {...register("bankAccount")}
                                                />
                                              </div>
                                            </div>
                                          </div>{" "}
                                        </>
                                      )}
                                      <div
                                        _ngcontent-serverapp-c684031653
                                        className="ng-tns-c684031653-19 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                                      >
                                        <div
                                         
                                          _ngcontent-serverapp-c684031653
                                          className="menu-box active ng-tns-c684031653-19 ng-star-inserted"
                                        >
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="title ng-tns-c684031653-19"
                                          >
                                            <h2
                                              _ngcontent-serverapp-c684031653
                                              className="ng-tns-c684031653-19"
                                            >
                                              <span
                                                style={{ width: "auto" }}
                                                _ngcontent-serverapp-c684031653
                                                className="ng-tns-c684031653-19"
                                              >
                                                {t("DepositAmount")}
                                              </span>
                                              <i
                                                _ngcontent-serverapp-c684031653
                                                className="ng-tns-c684031653-19"
                                              >
                                                ৳{" "}
                                                {formatWithCommas(
                                                  limit?.minDeposit,
                                                )}{" "}
                                                - ৳{" "}
                                                {formatWithCommas(
                                                  limit?.maxDeposit,
                                                )}
                                              </i>
                                            </h2>
                                          </div>
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="check-group style-add-amount ng-tns-c684031653-19"
                                          >
                                            <ul
                                              _ngcontent-serverapp-c684031653
                                              className="col4 ng-tns-c684031653-19"
                                            >
                                              {number?.map((res, index) => {
                                                return (
                                                  <li
                                                    onClick={() =>
                                                      setValue("amount", res)
                                                    }
                                                    _ngcontent-serverapp-c684031653
                                                    className="ng-tns-c684031653-19 ng-star-inserted"
                                                  >
                                                    <input
                                                      _ngcontent-serverapp-c684031653
                                                      type="radio"
                                                      name="depositAmount"
                                                      className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                                                      id={`depositAmount_${index}`}
                                                    />
                                                    <label
                                                      _ngcontent-serverapp-c684031653
                                                      className="ng-tns-c684031653-19"
                                                      htmlFor={`depositAmount_${index}`}
                                                    >
                                                      <span
                                                        _ngcontent-serverapp-c684031653
                                                        className="ng-tns-c684031653-19"
                                                      >
                                                        +{" "}
                                                        {formatWithCommas(res)}
                                                      </span>
                                                    </label>
                                                  </li>
                                                );
                                              })}
                                            </ul>
                                          </div>
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="input-group money ng-tns-c684031653-19"
                                          >
                                            <label
                                              _ngcontent-serverapp-c684031653
                                              htmlFor="amount"
                                              className="ng-tns-c684031653-19"
                                            >
                                              ৳
                                            </label>
                                            <input
                                              _ngcontent-serverapp-c684031653
                                              drcinputnumberwithcomma
                                              className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                                              placeholder={0.0}
                                              type="text"
                                              inputMode="decimal"
                                              {...register("amount", {
                                                required: {
                                                  message:
                                                    "Please enter amount",
                                                },
                                                pattern: {
                                                  value: /^[0-9]*$/,
                                                  message:
                                                    "Please enter valid number",
                                                },
                                                validate: (value) => {
                                                  if (
                                                    !inRange(
                                                      value,
                                                      limit?.minDeposit,
                                                      limit?.maxDeposit,
                                                    )
                                                  ) {
                                                    return `Deposite amount should be in range of ${limit?.minDeposit} - ${limit?.maxDeposit}`;
                                                  } else {
                                                    return true;
                                                  }
                                                },
                                              })}
                                            />
                                            {errors.amount &&
                                              errors.amount.message && (
                                                <div
                                                  _ngcontent-serverapp-c3110418782
                                                  className="error-message-box ng-star-inserted"
                                                >
                                                  <div
                                                    _ngcontent-serverapp-c3110418782
                                                    className="error-message"
                                                  >
                                                    <span
                                                      _ngcontent-serverapp-c3110418782
                                                    >
                                                      {errors.amount.message}
                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        _ngcontent-serverapp-c684031653
                                        className="ng-tns-c684031653-19 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-serverapp-c684031653
                                          className="menu-box active ng-tns-c684031653-19 ng-star-inserted"
                                        >
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="title ng-tns-c684031653-19"
                                          >
                                            <h2
                                              _ngcontent-serverapp-c684031653
                                              className="ng-tns-c684031653-19"
                                            >
                                              <span
                                                style={{ width: "auto" }}
                                                _ngcontent-serverapp-c684031653
                                                className="ng-tns-c684031653-19"
                                              >
                                                {t("Transaction_ID")}
                                              </span>
                                            </h2>
                                          </div>

                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="input-group money ng-tns-c684031653-19"
                                          >
                                            <input
                                              _ngcontent-serverapp-c684031653
                                              className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                                              placeholder={"Transaction Id"}
                                              type="text"
                                              // inputMode="decimal"
                                              {...register("transactionId", {
                                                required: {
                                                  value: true,
                                                  message: t(
                                                    "enter_Transaction_ID",
                                                  ),
                                                },
                                                pattern: {
                                                  value:
                                                    validationRules.removeWhitespace,
                                                  message:
                                                    "Please enter only number or character",
                                                },
                                              })}
                                            />
                                            {errors.transactionId &&
                                              errors.transactionId.message && (
                                                <div
                                                  _ngcontent-serverapp-c3110418782
                                                  className="error-message-box ng-star-inserted"
                                                >
                                                  <div
                                                    _ngcontent-serverapp-c3110418782
                                                    className="error-message"
                                                  >
                                                    <span
                                                      _ngcontent-serverapp-c3110418782
                                                    >
                                                      {
                                                        errors.transactionId
                                                          .message
                                                      }
                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        _ngcontent-serverapp-c684031653
                                        className="ng-tns-c684031653-19 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-serverapp-c684031653
                                          className="menu-box active ng-tns-c684031653-19 ng-star-inserted"
                                        >
                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="title ng-tns-c684031653-19"
                                          >
                                            <h2
                                              _ngcontent-serverapp-c684031653
                                              className="ng-tns-c684031653-19"
                                            >
                                              <span
                                                style={{ width: "auto" }}
                                                _ngcontent-serverapp-c684031653
                                                className="ng-tns-c684031653-19"
                                              >
                                                {t("Upload_Receipt")}
                                              </span>
                                            </h2>
                                          </div>

                                          <div
                                            _ngcontent-serverapp-c684031653
                                            className="input-group money ng-tns-c684031653-19"
                                          >
                                            <input
                                              style={{ paddingTop: "7px" }}
                                              _ngcontent-serverapp-c684031653
                                              className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                                              placeholder={"Transaction Id"}
                                              type="file"
                                              accept="image/png, image/jiffy, image/jpeg, image/jpg"
                                              onChange={(e) => {
                                                setImage(e.target.files[0]);
                                              }}
                                            />
                                          </div>
                                          {image !== "" && (
                                            <div
                                              _ngcontent-serverapp-c684031653
                                              className="member-content ng-tns-c684031653-19 ng-star-inserted"
                                            >
                                              <div
                                                _ngcontent-serverapp-c684031653
                                                className="button btn-primary ng-tns-c684031653-19"
                                              >
                                                <button
                                                  type="submit"
                                                  className="ng-tns-c684031653-19"
                                                  style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    width: "100%",
                                                    height: "100%",
                                                    color: "white",
                                                    fontWeight: "600",
                                                    fontSize: "20px",
                                                  }}
                                                >
                                                  {t("RemoveImage")}
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div
                                        _ngcontent-serverapp-c684031653
                                        className="member-content ng-tns-c684031653-19 ng-star-inserted "
                                      >
                                        <div
                                          _ngcontent-serverapp-c684031653
                                          className="button btn-primary ng-tns-c684031653-19 "
                                        >
                                          <button
                                            type="submit"
                                            disabled={loader}
                                            className="ng-tns-c684031653-19"
                                            style={{
                                              background: "transparent",
                                              border: "none",
                                              cursor: "pointer",
                                              width: "100%",
                                              height: "100%",
                                              color: "black",
                                              fontWeight: "600",
                                              fontSize: "20px",
                                            }}
                                          >
                                            {t("Submit")}
                                          </button>
                                        </div>
                                      </div>
                                    </Form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-component>
                        </div>
                      )}
                      {tab == "withdraw" && <Withdraw />}
                    </ng-component>
                  </ng-component>
                </div>
              </div>
            </div>{" "}
          </ConditionalOutsideClick>
        </div>
      </app-popup-page>{" "}
    </Layout>
  );
};

export default Deposit;

const number = [100, 300, 500, 1000, 5000, 10000, 20000, 50000];
